export const POST_BUTTON_LABEL = 'POST_BUTTON_LABEL';

export function postButtonLabel(buttonLabel: any) {
  return {
    type: POST_BUTTON_LABEL,
    buttonLabel: buttonLabel
  };
}